type Delimiter = "\n" | "," | ";" | "|" | "\t";

// Helpful for when reading csv or txt contents
export function parseDelimitedText(text: string, delimiter: Delimiter = "\n"): string[] {
    return text
        .split(delimiter)
        .map(s => s.trim())
        .filter(s => s !== "");
}
